import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";

// 引入全局样式
import "../src/assets/stylus/reset.styl";
//引入ElementUI框架
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// 全局方法
import filters from "./filters/index";
Vue.prototype.filters = filters;

//富文本编辑器
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(VueQuillEditor);

Vue.prototype.$baseUrl = process.env.TARGET;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
